let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5zFT3")).then(() => parcelRequire('2DhQP'));